import { useEffect } from 'react'
import { SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import PATHS, { buildHomeThreadPath } from '@/routes/paths'

/** @param {object} m */
export function useSyncDisplayThreadUrl(m) {
  const {
    activePrimaryKey,
    homeView,
    displayThreadId,
    navThreads,
    threadMatch,
    navigate,
  } = m

  useEffect(() => {
    if (activePrimaryKey !== 'home' || homeView !== SECONDARY_VIEW_KEYS.HOME_MAIN) return

    if (!displayThreadId) {
      if (threadMatch) navigate(PATHS.HOME, { replace: true })
      return
    }

    if (!navThreads.some((t) => t.id === displayThreadId)) return

    const urlId = threadMatch?.params?.threadId
    if (urlId !== displayThreadId) {
      navigate(buildHomeThreadPath(displayThreadId), { replace: true })
    }
  }, [
    activePrimaryKey,
    homeView,
    displayThreadId,
    navThreads,
    threadMatch?.params?.threadId,
    navigate,
    threadMatch,
  ])
}
